import { Input } from 'antd';
import React from 'react';
import debounce from 'lodash/debounce';
import { GLOBAL_DEBOUNCE_TIME } from '../../utils/DataConstants';

interface OWSearchInputProps {
	onChange?: (value: string) => void;
	onSearch?: (value: string) => void;
	[key: string]: any;
}

class OWSearchInput extends React.PureComponent<OWSearchInputProps, { value: string }> {
	private debouncedOnChange: ReturnType<typeof debounce>;

	constructor(props: OWSearchInputProps) {
		super(props);
		this.state = {
			value: props.value || '',
		};

		this.debouncedOnChange = debounce((value: string) => {
			if (this.props.onChange) {
				this.props.onChange(value);
			}
		}, GLOBAL_DEBOUNCE_TIME);

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(e: React.ChangeEvent<HTMLInputElement>) {
		const value = e.target.value;
		this.setState({ value });
		this.debouncedOnChange(value);
	}

	render() {
		const { onChange, ...restProps } = this.props;

		return (
			<Input.Search
				style={{ width: 180 }}
				{...restProps}
				value={this.state.value}
				onChange={this.handleChange}
			/>
		);
	}
}

export default OWSearchInput;
